import type { ReactElement } from "react";
import { Navigate } from "react-router-dom";
import { getAccessTokenClaims } from "@zenith/services/token";
import { DASHBOARD } from "@zenith/routes/paths";
import { useCurrentRole } from "@zenith/features/AuthZ/useCurrentRole";
import { can, type Permission } from "@zenith/features/AuthZ/permissions";
import { useBusinessType } from "@zenith/features/TeamManagement";

export interface MerchantOnlyRouteProps {
  children: ReactElement;
  /** The BOAS-7641 permission this screen requires - admin always holds it. */
  permission: Permission;
}

/**
 * Screens BOAS-7641 scopes by role and business type rather than just "is the
 * owner": a Manager reaches the ones their row grants (their own outlet's
 * management, POS and withdrawal history, VAAS under Multi-signatory),
 * Admin reaches all of them, and Accountant/Cashier are turned back the same
 * as a visitor with no token at all.
 */
const MerchantOnlyRoute = ({
  children,
  permission,
}: MerchantOnlyRouteProps) => {
  const claims = getAccessTokenClaims();
  const teamRole = useCurrentRole();
  const businessType = useBusinessType();

  if (!claims || !can(teamRole, businessType, permission)) {
    return <Navigate to={DASHBOARD} replace />;
  }

  return children;
};

export default MerchantOnlyRoute;
